import React, { Component } from 'react'
import { Draggable, Droppable } from 'react-beautiful-dnd'
import Icon from 'components/icon/icon'
import { connect } from 'react-redux'

import MilestoneName from './milestone-name'

import NewTask from '../project-tasks-new'

import Task from '../task/task'

import SmoothCollapse from 'react-smooth-collapse'

import Scroll from 'react-scroll'

import {
	isMobile,
} from 'utils'

import { clone } from 'lodash'
import isEqual from 'react-fast-compare'

import {
	doClickEventListeners,
	getPrimaryColumnValue,
	getColumns,
	getHeadingLabels
} from 'utils'

class Milestone extends Component {
	state = {
		tempTask: null,
		isMobileSubMenuOpen: false
	}

	lastRenderedTaskId = null
	scroll = Scroll.animateScroll
	previousRenderedScreenWidth = window.innerWidth
	columns = []

	UNSAFE_componentWillMount() {
		doClickEventListeners(this.handleClick)

		this.getColumns()

		window.addEventListener('resize', this.handleResize)
	}

	componentWillUnmount() {
		doClickEventListeners(this.handleClick, true)

		window.removeEventListener('resize', this.handleResize)
	}

	componentDidMount() {
		const {
			milestone,
			addMilestoneRef
		} = this.props

		if (milestone && this.milestoneHeaderRef) {
			addMilestoneRef(milestone, this.milestoneHeaderRef)
		}

		this.setState({
			taskNameWidth: this.getTaskNameWidth()
		})
	}

	componentDidUpdate = prevProps => {
		// SIGH, once again all transitions will break if we remove this for some ~nebulous~ reason.
		setTimeout(_ => {
			if (isMobile()) {
				const {
					milestone,
					menuState,
					isLast,
					mobileSpacerHeight,
					setSpacerHeight
				} = this.props

				let newSpacerHeight = 0

				let isTaskInMilestone = milestone.tasks.find(task => {
					return task.id === menuState.currentFocusedTask || task.id === prevProps.menuState.currentFocusedTask
				})

				if (isLast && isTaskInMilestone) {
					if (this.lastRenderedTaskId && menuState.currentFocusedTask === this.lastRenderedTaskId) {
						const isDate = (menuState.currentOpenColumnId.toString().includes('start') || menuState.currentOpenColumnId.toString().includes('end'))
						newSpacerHeight = isDate ? 150 : 95
					} else {
						newSpacerHeight = 0
					}

					if (mobileSpacerHeight != newSpacerHeight) {
						setSpacerHeight(newSpacerHeight)

						setTimeout(_ => {
							this.scrollToBottom()
						}, 200)
					}
				}
			}

			const newTaskNameWidth = this.getTaskNameWidth()

			if(newTaskNameWidth !== this.state.taskNameWidth){
				this.setState({
					taskNameWidth: newTaskNameWidth
				})
			}
		}, 1)
	}

	scrollToBottom = _ => {
		this.scroll.scrollToBottom({
			duration: 150,
			delay: 0,
			smooth: "easeInOutQuint",
		})
	}

	handleClick = e => {
		let isTaskInGroup = this.props.milestone.tasks.find(task => {
			return task.id === this.props.menuState.currentFocusedTask;
		})

		if (isTaskInGroup && (!this.ref || !this.ref.contains(e.target))) {
			this.props.openMenu(null)
		}
	}

	handleResize = _ => {
		const thisWidth = window.innerWidth

		if (thisWidth <= 1470 && this.previousRenderedScreenWidth > 1470) {
			this.forceUpdate()
		} else if (thisWidth > 1470 && this.previousRenderedScreenWidth <= 1470) {
			this.forceUpdate()
		}

		this.previousRenderedScreenWidth = thisWidth
	}

	addTempTask = name => {
		this.setState({
			tempTask: name
		})
	}

	shouldBlockTransition = false

	UNSAFE_componentWillUpdate = nextProps => {
		const {
			isPremium,
			currentProject,
			milestone
		} = this.props

		if (milestone.tasks.length !== nextProps.milestone.tasks.length) {
			this.setState({
				tempTask: null
			})
		}

		if (!isMobile() && isPremium && currentProject) {
			const currentlyHasTiming = currentProject.has_timing
			const willHaveTiming = nextProps.currentProject.has_timing

			if (currentlyHasTiming !== willHaveTiming) {
				this.shouldBlockTransition = true

				setTimeout(_ => {
					this.shouldBlockTransition = false
					this.forceUpdate()
				}, 10)
			}
		}
	}

	shouldComponentUpdate = nextProps => {
		const {
			visibleIds
		} = this.props

		if (!isEqual(visibleIds, nextProps.visibleIds)) {
			let hasRelevantIds = false
			let hadRelevantIds = false

			nextProps.milestone.tasks.forEach(task => {
				if (visibleIds.indexOf(task.id) !== -1) {
					hadRelevantIds = true
				}

				if (nextProps.visibleIds.indexOf(task.id) !== -1) {
					hasRelevantIds = true
				}
			})

			if (!hasRelevantIds && !hadRelevantIds) {
				return false
			}
		}

		return true
	}

	collapseCallback = _ => {
		const {
			collapseCallback,
			milestone
		} = this.props

		collapseCallback(milestone.id)
	}

	setMobileSubMenuOpenStatus = isOpen => {
		this.setState({
			isMobileSubMenuOpen: isOpen
		})
	}

	hasFeature = feature => {
		const {
			isPremium,
			currentProject,
			isCapacity,
			isQuickTasks
		} = this.props

		if (feature === 'restrict_guest_visibility') {
			return isPremium && currentProject && currentProject.restrict_guest_visibility
		}

		if (!isPremium || isMobile()) {
			return false
		}

		switch (feature) {
			case 'gantts':
				return isCapacity || isQuickTasks || (currentProject && currentProject.has_gantts)
			case 'timing':
				return isCapacity || isQuickTasks || (currentProject && currentProject.has_timing)
		}
	}

	getHeadingLabels = _ => {
		return getHeadingLabels(this.columns, this.hasFeature)
	}

	isCompact = _ => {
		const screenWidth = window.innerWidth
		const isCompact = screenWidth <= 1470

		return isCompact
	}

	getTaskNameWidth = _ => {
		let lengthOfOtherColumns = 0

		const isCompact = this.isCompact()

		this.columns && this.columns.forEach(column => {
			switch (column.type) {
				case 'PROJECT':
					lengthOfOtherColumns += isCompact ? 120 : 160
					break
				case 'PEOPLE':
					lengthOfOtherColumns += isCompact ? 155 : 200
					break
				case 'STATUS':
					lengthOfOtherColumns += isCompact ? 120 : 160
					break
				case 'DATE':
					if (this.hasFeature('gantts') && column.is_primary) {
						lengthOfOtherColumns += 155
					} else {
						lengthOfOtherColumns += 95
					}
					break
				case 'TEXT':
				case 'LINK':
					lengthOfOtherColumns += isCompact ? 160 : 220
					break
			}
		})

		if (this.hasFeature('timing')) {
			lengthOfOtherColumns += 90
		}

		return `calc(100% - ${lengthOfOtherColumns}px)`
	}

	shouldHide = task => {
		const {
			isHidingComplete,
			roles,
			userData,
			currentProject
		} = this.props

		if (!userData) {
			return false
		}

		const userId = userData.id
		const statusId = getPrimaryColumnValue('status', task, currentProject)

		let shouldHide = isHidingComplete && statusId == 3

		const taskUsers = getPrimaryColumnValue('people', task, currentProject)

		if (!shouldHide && roles.guest && this.hasFeature('restrict_guest_visibility') && task.id && taskUsers) {
			if (!taskUsers.includes(userId) && task.created_by !== userId && (!task.tagged_user_ids || !task.tagged_user_ids.includes(userId))) {
				shouldHide = true
			}
		}

		return shouldHide
	}

	getColumns = _ => {
		const {
			currentProject,
			isPremium,
			isCapacity,
			isQuickTasks
		} = this.props

		if (isCapacity || isQuickTasks) {
			this.columns = [
				{
					id: -1,
					type: 'PROJECT'
				},
				{
					id: -2,
					type: 'PEOPLE',
					is_primary: true
				},
				{
					id: -3,
					type: 'STATUS',
					is_primary: true
				},
				{
					id: -4,
					type: 'DATE',
					is_primary: true
				}
			]
		} else {
			this.columns = getColumns(currentProject, isPremium)
		}
	}

	render() {
		if (!this.props.milestone) {
			return null
		}

		const {
			addTaskOffset,
			addTaskRef,
			applicableUsers,
			areMilestonesReordering,
			currentEditedTask,
			currentFocusedTask,
			currentProject,
			currentTaskId,
			deleteMilestone,
			draggedTaskId,
			editTaskName,
			forceAddVisibleId,
			handleInputFocus,
			isArchivedProject,
			isCapacity,
			isLast,
			isMini,
			isOpen,
			isPremium,
			isQuickTasks,
			isShowingArchived,
			loading,
			menuState,
			milestone,
			milestoneIndex,
			openMenu,
			restoreMilestone,
			searchTerm,
			statuses,
			taskUpdateCallback,
			userData,
			visibleIds,
		} = this.props

		const {
			tempTask,
			isMobileSubMenuOpen,
			taskNameWidth
		} = this.state

		this.getColumns()

		const isDraggedTaskInMilestone = (() => {
			return draggedTaskId ? milestone.tasks.find(task => task.id === draggedTaskId) : false
		})()

		const hasTiming = this.hasFeature('timing')
		const hasGantts = this.hasFeature('gantts')

		let className = "milestone-container"

		if (!hasGantts) {
			className += ' single-date'
		}

		if (isDraggedTaskInMilestone || isMobileSubMenuOpen) {
			className += ' force-top'
		}

		if (!isOpen) {
			className += ' collapsed'
		}

		if (isShowingArchived) {
			className += ' archived'
		}

		if (this.shouldBlockTransition) {
			className += ' block-transition'
		}

		let tasks = []

		if (loading && (!milestone.tasks || !milestone.tasks.length || milestone.tasks.length < milestone.taskCount)) {
			tasks = []

			for (let i = 0; i < milestone.taskCount; i++) {
				tasks.push(i)
			}
		} else {
			tasks = milestone.tasks
		}

		const isPlanning = isQuickTasks || isCapacity

		const isProjectEditable = isPlanning || (!isArchivedProject && !isShowingArchived)

		const areEntitiesRecoverable = !isArchivedProject && isShowingArchived

		let taskIterator = -1

		const headingLabels = this.getHeadingLabels()

		const isCompact = this.isCompact()

		const commonTaskProps = {
			addTaskOffset,
			addTaskRef,
			areEntitiesRecoverable,
			applicableUsers,
			columns: this.columns,
			currentEditedTask,
			currentFocusedTask,
			currentProject,
			editTaskName,
			hasGantts,
			hasTiming,
			isPremium,
			isProjectEditable,
			isCompact,
			loading,
			menuState,
			milestone,
			milestoneIndex,
			openMenu,
			statuses,
			taskNameWidth,
			userData,
			visibleIds
		}

		if (areMilestonesReordering) {
			return (
				<Draggable
					disableInteractiveElementBlocking={true}
					index={milestoneIndex}
					draggableId={'milestone-' + milestone.id}
					type="MILESTONE"
				>
					{provided => (
						<div
							ref={provided.innerRef}
							data-index={milestoneIndex}
							className="draggable"
						>
							<div {...provided.draggableProps} {...provided.dragHandleProps}>
								<li
									style={{ zIndex: this.props.zIndex }}
									ref={provided.innerRef}
									className={className}
									key={milestoneIndex}
								>
									<div className="milestone-header">
										<MilestoneName
											name={milestone.name}
											milestone={milestone}
											index={milestoneIndex}
											deleteMilestone={deleteMilestone}
											areMilestonesReordering={areMilestonesReordering}
											setMobileSubMenuOpenStatus={this.setMobileSubMenuOpenStatus}
										/>
									</div>
								</li>
							</div>
							{provided.placeholder}
						</div>
					)}
				</Draggable>
			)
		} else {
			return (
				<Droppable
					droppableId={'milestone-' + milestone.id}
					type="TASK"
				>
					{provided => (
						<li
							style={{ zIndex: this.props.zIndex }}
							ref={provided.innerRef}
							className={className}
							key={milestoneIndex}
						>
							<div
								className="milestone-header"
								ref={ref => this.milestoneHeaderRef = ref}
							>
								<MilestoneName
									areEntitiesRecoverable={areEntitiesRecoverable}
									taskNameWidth={taskNameWidth}
									isShowingArchived={isShowingArchived}
									name={milestone.name}
									milestone={milestone}
									index={milestoneIndex}
									deleteMilestone={deleteMilestone}
									restoreMilestone={restoreMilestone}
									isOpen={isOpen}
									isMini={isMini}
									collapseCallback={this.collapseCallback}
									isProjectEditable={isProjectEditable}
									setMobileSubMenuOpenStatus={this.setMobileSubMenuOpenStatus}
									isPlanning={isPlanning}
								/>
								{headingLabels.map(label => {
									const {
										className,
										title
									} = label

									return (
										<label
											className={className}
											key={title}
											dangerouslySetInnerHTML={{ __html: title }}
										/>
									)
								})}
								{!isMini &&
									<span className={!isOpen ? 'milestone-toggle toggled' : "milestone-toggle"} onClick={this.collapseCallback}>
										<Icon name="angle-up" />
									</span>
								}
							</div>
							<div ref={e => this.ref = e}>
								<SmoothCollapse expanded={isOpen} allowOverflowWhenOpen={true}>
									<ul className="milestone-tasks" onClick={e => { e.stopPropagation(); }}>
										<div className="milestone-task-droppable">
											{tasks.map((task, i) => {
												let isVisible = true
												let className = 'task-list-item clear'
												let isFocused = null
												let draggableId

												if(task && task.isRecurredDuplicate){
													className += ` recurred-duplicate`
												}

												if (isMobile() || task.isRecurredDuplicate) {
													className += ' no-hover'
												}

												if (!loading) {
													draggableId = 'task-' + task.id

													if (!task || !task.name) {
														return
													}

													// Tasks randomly appear in the main project after they've been archived...
													if (!!isShowingArchived !== !!task.deleted_at) {
														return null
													}

													isVisible = task.name.toLowerCase().includes(searchTerm.toLowerCase())

													if (currentFocusedTask === task.id) {
														isFocused = true
														className += ' focused'
													} else if (draggedTaskId === task.id) {
														isFocused = true
													}

													if (isShowingArchived) {
														className += ' archived'
													}
												} else {
													draggableId = milestone.id + '_' + i
												}

												const zIndex = (isFocused || (task && task.id === currentTaskId)) ? 999 : (milestone.tasks.length - i)

												if (isVisible || loading) {
													this.lastRenderedTaskId = task.id

													taskIterator++

													const thisTaskIterator = clone(taskIterator)

													const shouldRender = (visibleIds.indexOf(task.id) !== -1) || !visibleIds.length

													const shouldHide = this.shouldHide(task)

													return (
														<div
															className={isFocused ? 'focused' : null}
															style={{ zIndex }}
															key={task.id ? task.id : i}
														>
															<Draggable
																isDragDisabled={isMobile() || !isProjectEditable || isPlanning}
																disableInteractiveElementBlocking={false}
																index={i}
																draggableId={draggableId}
																type="TASK"
															>
																{provided => (
																	<div
																		ref={provided.innerRef}
																		className={`task-container ${shouldHide ? 'hidden' : ''}`}
																	>
																		{ !shouldHide ?
																			<div
																				{...provided.draggableProps}
																				{...provided.dragHandleProps}
																			>
																				<Task
																					{...commonTaskProps}
																					className={className}
																					index={i}
																					taskIndex={thisTaskIterator}
																					shouldRender={shouldRender}
																					task={task}
																					isPlanning={isPlanning}
																					taskUpdateCallback={taskUpdateCallback}
																				/>
																			</div>
																			:
																			<div
																				{...provided.draggableProps}
																				{...provided.dragHandleProps}
																			/>
																		}
																		{provided.placeholder}
																	</div>
																)}
															</Draggable>
														</div>
													)
												}
											})}
											{
												tempTask ?
													<div>
														<Task
															isOptimistic={true}
															task={{
																id: -1,
																name: tempTask
															}}
															{...commonTaskProps}
															className={'task-list-item clear'}
															draggableProps={provided.draggableProps}
															dragHandleProps={provided.dragHandleProps}
															shouldRender={true}
														/>
													</div>
													: null
											}
											{provided.placeholder}
										</div>
										{
											(isProjectEditable && !isPlanning) ?
												<div className="new-task-container">
													<NewTask
														handleInputFocus={handleInputFocus}
														isLast={isLast}
														scrollToBottom={this.scrollToBottom}
														addTempTask={this.addTempTask}
														milestone={milestone}
														milestoneIndex={milestoneIndex}
														forceAddVisibleId={forceAddVisibleId}
														currentProject={currentProject}
													/>
												</div>
												: null
										}
									</ul>
								</SmoothCollapse>
							</div>
						</li>
					)}
				</Droppable>
			)
		}
	}
}

const mapStateToProps = (state, props) => {
	return {
		currentTaskId: state.account.currentTaskId
	}
}

export default connect(mapStateToProps, {})(Milestone)